// extracted by mini-css-extract-plugin
module.exports = {"swipeable_tab":"SwipeableTabs_swipeable_tab__F8H3Z","tab_item":"SwipeableTabs_tab_item__Zhv7t","tab_item_active":"SwipeableTabs_tab_item_active__cLfTy"};